import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2cc6256d&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/xujin/software/code/grail/grail-codegen-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__